import { render, staticRenderFns } from "./testpage.vue?vue&type=template&id=9c25f6b2&scoped=true"
import script from "./testpage.vue?vue&type=script&lang=js"
export * from "./testpage.vue?vue&type=script&lang=js"
import style0 from "./testpage.vue?vue&type=style&index=0&id=9c25f6b2&prod&lang=scss&scoped=true"
import style1 from "./testpage.vue?vue&type=style&index=1&id=9c25f6b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c25f6b2",
  null
  
)

export default component.exports